<template>
  <div class="text-image-block impact-module">
    <div class="inner">
      <div
        v-if="data.has_border"
        class="border"
      ></div>

      <div v-if="data.title" class="title">
        <div class="title-inner">
          <h2>{{ data.title }}</h2>
        </div>
      </div>

      <div class="content">
        <div class="content-inner" :class="alignmentClass">
          <div class="text">
            <div class="text-content" v-html="data.text" v-if="data.text"></div>

            <a v-if="hasLink" :href="data.link">{{ data.link_text }}</a>
            <a v-else-if="hasFile" :href="data.file_to_download" download>{{ data.link_text }}</a>
          </div>
          
          <div class="image">
            <img :src="data.image.poster" :alt="data.image.alt">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextBlock',
  props: {
    data: Object
  },
  computed: {
    hasLink() {
      return this.data.link && this.data.link !== '' && this.data.link_text && this.data.link_text !== ''
    },
    hasFile() {
      return this.data.file_to_download && this.data.file_to_download !== '' && this.data.link_text && this.data.link_text !== ''
    },
    alignmentClass() {
      if (this.data.alignment === 'left') {
        return 'text-left'
      } else if (this.data.alignment === 'right') {
        return 'text-right'
      } else if (this.data.alignment === 'centered') {
        return 'centered'
      } else {
        return 'text-left'
      }
    }
  }
}
</script>

<style scoped>
.text-image-block {
  padding: 0 2rem;
}

.text-image-block>.inner {
  /* border-top: 1px dashed white;
  padding: 10rem 0; */
}

.title .title-inner {
  /* border-top: 1px dashed white;
  padding-top: 5rem; */
  /* padding-top: 10rem; */
  /* padding-top: 6rem; */
}

.title h2 {
  font: var(--nord-title);
  text-align: center;
  margin-bottom: 1rem;
}

.content-inner {
  display: flex;
  align-items: center;
  max-width: 1500px;
  margin: 0 auto;
  flex-wrap: wrap;
}

.content-inner.centered {
  max-width: 1000px;
}

.content-inner.text-left .text {
  order: 1;
  padding-right: 10rem;
}

.content-inner.text-left .image {
  order: 2;
}

.content-inner.text-right .text {
  order: 2;
  padding: 0 8rem;
}

.content-inner.text-right .image {
  order: 1;
}

.text,
.image {
  width: 50%;
}

.image {
  /* padding: 100px; */
  padding: 30px 100px;
}

.content-inner.centered .text,
.content-inner.centered .image {
  width: 100%;
}

.content-inner.centered .text {
  order: 2;
  padding: 0 10rem;
}

.content-inner.centered .image {
  order: 1;
  margin-bottom: 4rem;
}

.text-content {
  font: var(--serif-small);
}

.text a {
  border: 1px dashed white;
  font: var(--nord);
  text-transform: uppercase;
  text-align: center;
  padding: 1.5rem;
  display: inline-block;
  margin-top: 2rem;
}

.text a:hover {
  background-color: white;
  color: black;
}

@media (max-width: 1000px) {
  .text,
  .image {
    width: 100%;
  }

  .image {
    margin-bottom: 2rem;
    padding: 0px;
  }

  .content-inner.text-right .text,
  .content-inner.text-left .text {
    order: 2;
    padding: 0rem;
  }

  .content-inner.text-right .image,
  .content-inner.text-left .image {
    order: 1;
    padding: 0;
  }

  .content-inner.centered .text {
    padding: 0rem;
  }
}
</style>